import React, { FC, Fragment } from 'react';
import { Trans } from 'react-i18next';
import { Grid, Hidden, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Layouts } from 'components';

import { Activity, Client, MyReach, Sharing, Tabs } from '../components';

const useStyles = makeStyles({
  flexItem: {
    display: 'flex',
  },
  stretchItem: {
    display: 'flex',
    alignItems: 'stretch',
    flexBasis: 'auto',
  },
  emptyStateWrapper: {
    position: 'relative',
    height: '100%',
  },
  center: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
  },
});

const ActivityIndex: FC = () => {
  const classes = useStyles();

  function renderActivityEmptyState() {
    return (
      <div className={classes.emptyStateWrapper}>
        <img className={classes.center} src="/images/graph.svg" />
        <Typography align="center" className={classes.center} variant="subtitle2">
          <Trans i18nKey="emptyStates:activityActivity" />
        </Typography>
      </div>
    );
  }

  function renderMyReachEmptyState() {
    return (
      <div className={classes.emptyStateWrapper}>
        <img className={classes.center} src="/images/circle-graph-copy.svg" />
        <Typography align="center" className={classes.center} variant="subtitle2">
          <Trans i18nKey="emptyStates:activityMyReach" />
        </Typography>
      </div>
    );
  }

  function renderTopHalf() {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} lg={4}>
          <Activity emptyState={renderActivityEmptyState} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <MyReach emptyState={renderMyReachEmptyState} />
        </Grid>
        <Grid item xs={12} lg={4} className={classes.flexItem}>
          <Grid container direction="column" spacing={3}>
            <Grid item xs className={classes.stretchItem}>
              <Sharing />
            </Grid>
            <Grid item xs className={classes.stretchItem}>
              <Client />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function renderBottomHalf() {
    return (
      <Hidden mdDown>
        <Paper>
          <Tabs />
        </Paper>
      </Hidden>
    );
  }

  return (
    <Layouts.App1Column
      fullWidth
      main={
        <Fragment>
          <Grid container direction="column" spacing={3} wrap="nowrap">
            <Grid item xs>
              {renderTopHalf()}
            </Grid>
            <Grid item xs>
              {renderBottomHalf()}
            </Grid>
          </Grid>
        </Fragment>
      }
    />
  );
};

export default ActivityIndex;
